import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const DialogContext = React.createContext({
    open: () => { },
    close: () => { },
    dialogs: {},
});
export const DialogsProvider = ({ children }) => {
    const [dialogs, setDialogs] = React.useState({});
    const open = (key) => {
        setDialogs(Object.assign(Object.assign({}, dialogs), { [key]: { isOpen: true } }));
    };
    const close = (key) => {
        setDialogs(Object.assign(Object.assign({}, dialogs), { [key]: { isOpen: false } }));
    };
    return (_jsx(DialogContext.Provider, Object.assign({ value: {
            dialogs,
            open,
            close,
        } }, { children: children })));
};
export const useDialog = (id) => {
    const dialogs = React.useContext(DialogContext);
    const open = () => dialogs.open(id);
    const close = () => dialogs.close(id);
    const state = dialogs.dialogs[id] || { isOpen: false };
    return {
        open,
        close,
        state,
    };
};
